import React, { useState } from "react"
import Box from "@mui/material/Box"
import CustomButton from "../../custom-button"
import { useDeleteDose } from "../../../hooks/use-dose"


export default function DeleteDoseForm({
    estateId,
    doseId,
    appliancePlanId,
}: {
    estateId: number,
    doseId: number,
    appliancePlanId: number,
}) {

    const [confirmation, setConfirmation] = useState<boolean>(false)

    const mutation = useDeleteDose(estateId, doseId, appliancePlanId)

    return (
        <Box>
            <Box display="flex" justifyContent="center" gap={1} mt={2}>
                {!confirmation &&
                    <CustomButton
                        variant="outlined"
                        color="error"    
                        text="Odstranit"
                        onClick={() => setConfirmation(true)}
                    />
                }
                {confirmation &&
                    <>
                        <CustomButton
                            color="error" 
                            text="Potvrdit"
                            disabled={mutation.isPending}
                            onClick={() => mutation.mutate()}
                        />
                        <CustomButton
                            variant="outlined"
                            text="Zrušit"
                            onClick={() => setConfirmation(false)}
                        />
                    </>
                }
            </Box>
            <Box>
                {mutation.isError ? (
                    <div>Došlo k chybě: {mutation.error.message}</div>
                ) : null}
            </Box>
        </Box>
    )
}
